import {
  DELETE_INTELLECTUAL_PROPERTY_RIGHTS,
  GET_INTELLECTUAL_PROPERTY_RIGHTS,
  GET_INTELLECTUAL_PROPERTY_RIGHTS_LIST,
  POST_INTELLECTUAL_PROPERTY_RIGHTS,
  PUT_INTELLECTUAL_PROPERTY_RIGHTS,
} from "../constants/actionTypes";

const defaultState = {
  intellectualPropertyRightsArr:[],
  intellectualPropertyRights:{}
};
let data=[]
export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_INTELLECTUAL_PROPERTY_RIGHTS_LIST:
        return {...state,intellectualPropertyRightsArr:[...action.payload]};
      case GET_INTELLECTUAL_PROPERTY_RIGHTS:
        return {...state,intellectualPropertyRights:{...action.payload}};
      case POST_INTELLECTUAL_PROPERTY_RIGHTS:
        return {...state,intellectualPropertyRightsArr:[...state?.intellectualPropertyRightsArr,action.payload]};
      case PUT_INTELLECTUAL_PROPERTY_RIGHTS:
        data = [...state?.intellectualPropertyRightsArr];
        index = data?.findIndex(
          (setting) => setting?.id_customer === action.payload?.id_customer,
        );
        if (index != -1) data[index] = { ...action?.payload };
        return {...state,intellectualPropertyRightsArr: [...data]};
      case DELETE_INTELLECTUAL_PROPERTY_RIGHTS:
        data = [...state?.intellectualPropertyRightsArr];
        const newData = data?.filter(
          (income) => income.id!=action.payload,
        );
        return {...state,intellectualPropertyRightsArr: [...newData]};
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
